<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">新增</span>
      </div>
    </div>
    <Form :label-width="100">
      <Row>
        <FormItem label="标题">
          <Input
            v-model="formItem.title"
            placeholder="请输入标题"
            style="width: 300px"
          ></Input>
        </FormItem>
        <FormItem label="类型">
          <Select v-model="formItem.type_id" style="width: 300px">
            <Option v-for="item in types" :value="item.id" :key="item.id">{{
              item.type_name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="详情">
          <vue-editor
            v-model="formItem.content"
            useCustomImageHandler
            @imageAdded="handleImageAdded"
          ></vue-editor>
        </FormItem>
      </Row>
      <FormItem label>
        <Button type="success" @click="save" :loading="loading">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueEditor } from 'vue2-editor'
import config from '@/config'

export default {
  components: { VueEditor },
  data () {
    return {
      formItem: {
        title: '',
        content: '',
        is_del: 0,
        id: 0,
        type_id: 0
      },
      types: [],
      loading: false
    }
  },
  methods: {
    ...mapActions(['GetHelpDetails', 'GetHelpTypes', 'SaveHelp', 'ImagesUpload']),
    getData () {
      this.GetHelpDetails({ id: this.formItem.id }).then((res) => {
        this.formItem = res.data
      })
    },
    handleImageAdded (file, Editor, cursorLocation) {
      if (file.size > 800 * 1024) {
        this.$Message.warning({
          content: `图片过大(${file.name}),为避免用户加载时间过长,推荐裁剪后再编辑`,
          duration: 5
        })
        return false
      }
      var formData = new FormData()
      formData.append('file', file)
      this.ImagesUpload(formData).then((res) => {
        if (res.code === 1) Editor.insertEmbed(cursorLocation, 'image', res.path)
      })
    },
    save () {
      this.loading = true
      console.log(this.formItem)
      this.SaveHelp(this.formItem).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (!res.status) {
          return false
        }
        setTimeout(() => {
          this.$router.back()
        }, 1500)
      })
    },
    getTypes () {
      this.GetHelpTypes().then((res) => {
        this.types = res.data
      })
    }
  },
  mounted () {
    this.getTypes()
    this.formItem.id = this.$route.query.id
    if (this.formItem.id && this.formItem.id > 0) this.getData()
  },
  created () {

  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
